import React, { useState } from "react";
import onClickOutside from "react-onclickoutside";
import { v4 as uuidv4 } from "uuid";

function NumberDropdown(props) {
  const sections = [
    ["1", "button-1"],
    ["2", "button-2"],
    ["3", "button-3"],
    ["4", "button-4"],
  ];
  const index = props.permission ? props.permission : 1;
  const [open, setOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState(sections[index - 1]);
  NumberDropdown[`handleClickOutside_` + props.item] = () => setOpen(false);

  const handleChange = (section) => {
    setCurrentSection([section[0], section[1]]);
    if (props.customPermissions && props.setCustomPermissions) {
      let newRecipients = [...props.customPermissions];
      newRecipients[props.idx].permission = section[0];
      props.setCustomPermissions(newRecipients);
    }
  };

  const toggle = () => setOpen(!open);
  return (
    <div className="number-wrapper ">
      <div className="number-inner ">
        <div className="" onClick={() => toggle(!open)}>
          <div className="number-title d-flex justify-content-around align-items-center">
            <span className={`${currentSection[1]} smaller ml-3`}>{currentSection[0]}</span>
            {open ? (
              <i style={{ pointerEvents: "none", color: "#2c345b" }} className="fas fa-sort-up"></i>
            ) : (
              <i style={{ pointerEvents: "none", color: "#2c345b" }} className="fas fa-sort-down"></i>
            )}
          </div>
        </div>
        <div className={`${open ? "" : "d-none"}`}>
          <div className="number-list">
            {sections.map((section) => {
              return (
                <div onClick={() => handleChange(section)} className="d-flex  pointer" key={uuidv4()}>
                  <div className={section[0] === "4" ? "pt-1 pb-3" : "py-1"}>
                    {section[0] === "1" ? (
                      <span className="pb-1  button-1">1</span>
                    ) : section[0] === "2" ? (
                      <span className="pb-1  button-2">2</span>
                    ) : section[0] === "3" ? (
                      <span className="pb-1  button-3">3</span>
                    ) : section[0] === "4" ? (
                      <span className="pb-1  button-4">4</span>
                    ) : undefined}
                  </div>
                </div>
              );
            })}
            <input hidden name={props.webName} value={currentSection[0]} readOnly />
          </div>
        </div>
      </div>
    </div>
  );
}

const clickOutsideConfig = {
  handleClickOutside: ({ props }) => NumberDropdown["handleClickOutside_" + props.item],
};

export default onClickOutside(NumberDropdown, clickOutsideConfig);
